export const USER_CURRENCY_COOKIE = "edx_user_currency";
export const DEFAULT_CURRENCY = "USD";
